var map = {
	"./MMBN1/ItemNames.json": 7894,
	"./MMBN2/ItemNames.json": 7307,
	"./MMBN3/ItemNames.json": 2284,
	"./MMBN4/ItemNames.json": 3817,
	"./MMBN5/ItemNames.json": 6506,
	"./MMBN6/ItemNames.json": 2175,
	"./MMSF1/ItemNames.json": 1801,
	"./MMSF2/ItemNames.json": 6224,
	"./MMSF3/ItemNames.json": 4591,
	"./OSS/ItemNames.json": 6776
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6524;